import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminHeader from '../../components/Shared/AdminHeader/AdminHeader';

export default function AdminLayout() {
  return (
    <>
      <AdminHeader />
      <main className="app-main">
        <Outlet />
      </main>
    </>
  );
}
